'use client';

import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const subscribe = (callback: () => void) => {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return () => {};
  }
  const mql = window.matchMedia(QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
};

const getSnapshot = () =>
  typeof window !== 'undefined' && !!window.matchMedia
    ? window.matchMedia(QUERY).matches
    : false;

// SSR + first client render return `false` (motion on) so markup matches; after
// hydration the real OS preference is read and updates reactively if it changes.
const getServerSnapshot = () => false;

/**
 * Reactive, SSR-safe read of the user's `prefers-reduced-motion` OS setting.
 *
 * Use it to turn OFF auto-motion (autoplaying video, looping marquee,
 * auto-advancing carousels) for people who asked their system to reduce motion.
 * NOTE: this is one layer — it does not by itself satisfy WCAG 2.2.2, which also
 * needs a pause control available to users who haven't set the OS flag.
 */
export const usePrefersReducedMotion = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
